import * as actionTypes from '../actions/actionTypes'
const initState = {
  response: [],
  resume: [],
  message: '',
  city:'',
}

export default (state = initState, action={}) => {
  switch (action.type) {
    case actionTypes.FIELD_POST_LIST_REQUEST:
      return {
        ...state,
        response: [],
        message: '',      
      }   
    case actionTypes.FIELD_POST_LIST_SUCCESS:
      return {
        ...state,
        response: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.FIELD_POST_LIST_ERROR:
      return {
        ...state,
        response:action.payload.response,
        message: 'Error',      
      }     
    case actionTypes.GET_CITY_BY_COUNTRY_LIST_REQUEST:
      return {
        ...state,
        responseCityByCountry: [],
        message: '',      
      }   
    case actionTypes.GET_CITY_BY_COUNTRY_LIST_SUCCESS:
      return {
        ...state,
        responseCityByCountry: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.GET_CITY_BY_COUNTRY_LIST_ERROR:
    
      return {
        ...state,
        responseCityByCountry:action.payload.response.data,
        message: 'Error',      
      }     
    case actionTypes.GET_COUNTRY_LIST_REQUEST:
      return {
        ...state,
        responseCityByCountry: [],
        message: '',      
      }   
    case actionTypes.GET_COUNTRY_LIST_SUCCESS:
      return {
        ...state,
        responseCountry: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.GET_COUNTRY_LIST_ERROR:
    
      return {
        ...state,
        responseCityByCountry:action.payload.response.data,
        message: 'Error',      
      }    
 
    case actionTypes.RESUME_FILE_POST_REQUEST:
      return {
        ...state,
        resume: [],
        message: '',      
      }   
    case actionTypes.RESUME_FILE_POST_SUCCESS: 
      return {
        ...state,
        resume: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.RESUME_FILE_POST_ERROR:
      return {
        ...state,
        resume: [],
        message: 'Error',      
      }
       case actionTypes.REQUEST_FIND_BY_CITY:
       
      return {
        ...state,
        city: action.payload,
        message: 'Error',      
      }  
      case actionTypes.REQUEST_DENIED_BY_CITY:
       
      return {
        ...state,
        city: false,
        message: 'Error',      
      }
       case actionTypes.REQUEST_SET_BY_CITY:
       
      return {
        ...state,
        setCity: action.payload,
        setCityB: action.payload2,
        message: 'Error',      
      }   
      case actionTypes.GET_ALL_CITY_LIST_REQUEST:
       
      return {
        ...state,
        allCitySuggetion: action.payload,
        message: 'Error',      
      }  
      case actionTypes.GET_ALL_CITY_LIST_SUCCESS:
       
      return {
        ...state,
        allCitySuggetion: action.payload&&action.payload.data,
        message: 'Error',      
      }
       case actionTypes.GET_ALL_CITY_LIST_ERROR:
       
      return {
        ...state,
        allCitySuggetion: action.payload.response,
        message: 'Error',      
      }      
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/FindRecCompany.js